angular.module('admin.directives')

  .directive('impersonationBar', ['SessionService', 'APP_CONFIG', function(SessionService, APP_CONFIG){
    return {
      restrict: 'E',
      controllerAs: 'impersonationBarCtrl',
      bindToController: {},
      scope: {},
      templateUrl: '/admin/templates/partials/impersonation-bar.html',

      controller: function(){
        var ctrl = this;

        ctrl.agentIsImpersonated = function(){
          if (_.isEmpty(SessionService.getLockboxToken())) {
            return false;
          }

          let tokenData = SessionService.extractJWT();

          if (tokenData.name) {
            ctrl.currentUserName = `${tokenData.name[0]} ${tokenData.name[1]}`;
          }

          return /^homebot:imp$/.test(tokenData.kind);
        };

        ctrl.backToDashboard = function(){
          window.location.href = `${APP_CONFIG.MAINSTREET_URL}/auth/company-admin`;
        };
      },

      link: function($scope, el, attrs, ctrl){

      }
    };

  }]);
